import { Helmet } from "react-helmet-async";
import { Sparkles, ArrowRight } from "lucide-react";

/* Neutrale Startseite von minibio.info – KEIN DIMEDIAL-Branding/Header/Footer.
   Zeigt sich für alle Nicht-Handle-Pfade sowie als freundlicher Fallback, wenn ein Handle nicht existiert. */
export default function MinibioHome() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-[#0F0F14] px-6 text-center text-white" data-testid="minibio-home">
      <Helmet>
        <title>minibio.info – deine eigene Mini-Website</title>
        <meta name="description" content="minibio.info – deine eigene Mini-Website: alle Links, Infos und Kontakt auf einer Seite." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://minibio.info/" />
      </Helmet>

      <div className="flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-[12px] font-semibold tracking-wide text-white/80" data-testid="minibio-badge">
        <Sparkles size={14} className="text-[#FDD105]" /> minibio.info
      </div>

      <h1 className="mt-7 max-w-[12ch] text-4xl font-black leading-[1.05] text-white sm:text-5xl" style={{ fontFamily: "'Outfit', sans-serif" }}>
        Deine eigene <span className="text-[#FDD105]">Mini-Website</span>.
      </h1>
      <p className="mt-4 max-w-[42ch] text-[15px] leading-relaxed text-white/60" style={{ fontFamily: "'Poppins', sans-serif" }}>
        Alle deine Links, Infos und dein Kontakt – auf einer schlanken Seite unter einer eigenen Adresse.
      </p>

      <a href="https://dimedial.studio/kunden/registrieren" data-testid="minibio-cta"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#FDD105] px-6 py-3 text-[15px] font-bold text-[#111] transition-transform hover:-translate-y-0.5"
        style={{ fontFamily: "'Poppins', sans-serif" }}>
        Eigene Mini-Website erstellen <ArrowRight size={17} strokeWidth={2.5} />
      </a>

      <p className="mt-6 text-[12px] text-white/35" style={{ fontFamily: "'Poppins', sans-serif" }}>
        Schon eine Seite? Deine Adresse lautet <span className="text-white/60">minibio.info/deinname</span>
      </p>
    </main>
  );
}
